import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/TextField": TextField, "@mui/material/Dialog": Dialog, "@mui/material/DialogTitle": DialogTitle, "@mui/material/DialogContent": DialogContent, "@mui/material/DialogContentText": DialogContentText, "@mui/material/DialogActions": DialogActions, "@mui/material/Button": Button, "@mui/material/Autocomplete": Autocomplete } } });
export default ClientProvider;
